import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.monitoring.admin.api');
import { OnInit, OnDestroy, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import moment from 'moment';

@Component({
    selector: 'wiz-portal-monitoring-admin-api',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.monitoring.admin.api/view.scss */
/* src/app/portal.monitoring.admin.api/view.scss: no such file or directory */`],
})
export class PortalMonitoringAdminApiComponent implements OnInit, OnDestroy {

    @Input() title: any;

    public map: any = {};
    public list: any[] = [];
    public facet: any = {};
    public machines: any[] = [];

    public searchForm: any = {};
    public math = Math;
    public loading: boolean = false;

    private routeSub: Subscription;

    constructor(@Inject( Service)         public service: Service,@Inject( Router)         private router: Router,@Inject( ActivatedRoute    )         private route: ActivatedRoute    ) {}

    public async ngOnInit() {

        await this.service.init();

        this.map.grade = '왕란,특란,대란,중란,소란,경란,파란,혈란,오란,등외'.split(',');

        const machineRes = await wiz.call('machines');
        this.machines = machineRes?.data || [];

        this.routeSub = this.route.queryParams.subscribe(async params => {

            if (params['date']) {
                this.searchForm.date = params['date'];
            } else {
                this.searchForm.date = moment().format('YYYY-MM-DD');
            }

            await this.load();
            await this.service.render();
        });
    }

    ngOnDestroy() {
        if (this.routeSub) this.routeSub.unsubscribe();
    }

    public async sync() {

        const pd = {
            date: moment(this.searchForm.date).format('YYYY-MM-DD')
        };

        const res = await wiz.call('sync', pd);
        if (res?.code !== 200) return;

        location.reload();
    }

    public async load() {
        this.loading = true;
        await this.service.render();

        const pd = {
            date: this.searchForm.date
        };

        const res = await wiz.call('search', pd);
        if (res?.code !== 200) {
            this.loading = false;
            await this.service.render();
            return;
        }

        this.list = res.data || [];
        this.loading = false;
        await this.service.render();
    }

    public searchSubmit() {

        const date = this.searchForm.date

        this.router.navigate(
            ['/admin/monitoring/api'],
            { queryParams: { date } }
        );
    }
}

export default PortalMonitoringAdminApiComponent;